import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NavigationEnd, Router } from '@angular/router';

import { NgcCookieConsentService, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

// declare gtag function for Google Analytics
declare function gtag(command: string, type: string, content: object): void;

// declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  // all of the pages the user can navigate to
  pages = ['browser', 'about', 'examples', 'docs'];

  browser: string;

  browserIssue: boolean;

  unsubscribe$ = new Subject<void>();

  constructor(private browserInfo: DeviceDetectorService, public router: Router, private cookiesService: NgcCookieConsentService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-715B8RZD19', {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }

  ngOnInit(): void {
    this.browser = this.browserInfo.browser;

    // if we run into issues down the road with different browsers/devices
    // that we need to inform users of, we can check for those here
    this.browserIssue = this.browser === 'IE';

    this.initCookieConsent();
  }

  initCookieConsent(): void {
    this.cookiesService.statusChange$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (event: NgcStatusChangeEvent) => {
        const consentMode = {
          functionality_storage: event.status === 'allow' ? 'granted' : 'denied',
          security_storage: event.status === 'allow' ? 'granted' : 'denied',
          ad_storage: event.status === 'allow' ? 'granted' : 'denied',
          analytics_storage: event.status === 'allow' ? 'granted' : 'denied',
          personalization: event.status === 'allow' ? 'granted' : 'denied',
          ad_user_data: event.status === 'allow' ? 'granted' : 'denied',
          ad_personalization: event.status === 'allow' ? 'granted' : 'denied',
          personalization_storage: event.status === 'allow' ? 'granted' : 'denied'
        };
        gtag('consent', 'update', consentMode);
        localStorage.setItem('consentMode', JSON.stringify(consentMode));
      });
  }
}
